/**
 * Feature flags for Products module.
 * Toggle Category selector/creation behavior without touching UI code.
 * SOLID-friendly: UI components read these flags to adjust behavior.
 */
export type ProductsFeatures = {
  categories: {
    enabled: boolean;
    allowCreateInline: boolean;
    allowRename: boolean;
  };
};

export const productsFeatures: ProductsFeatures = {
  categories: {
    enabled: true,
    allowCreateInline: true,
    allowRename: true,
  },
};